"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Process = void 0;
const index_1 = require("./Base/index");
const Constants_1 = require("./Constants");
/**
 * Describes a BPMN Process.
 * Any and all information about FlowNodes, SequenceFlows and Lanes is stored here.
 */
class Process extends index_1.BaseElement {
    constructor() {
        super(...arguments);
        /**
         * A list of all FlowNodes contained in this process.
         */
        this.flowNodes = [];
        /**
         * SequenceFlows link two FlowNodes together.
         */
        this.sequenceFlows = [];
        /**
         * Associations link a FlowNode to a TextAnnotation.
         */
        this.associations = [];
        /**
         * DataStoreReferences contain references to a permanent data store (Database, FileSystem, etc) that lies outside of the ProcessEngine.
         */
        this.dataStoreReferences = [];
        /**
         * DataObjectReferences contain references to a specific DataObject.
         */
        this.dataObjectReferences = [];
        /**
         * DataObjects can be used to store data during ProcessInstance execution.
         * Each DataObject is bound to a specific process and cannot be shared across multiple processs.
         */
        this.dataObjects = [];
    }
    /**
     * Returns all StartEvents contained in this process.
     */
    getStartEvents() {
        return this.flowNodes.filter((entry) => entry.bpmnType === Constants_1.BpmnType.startEvent);
    }
    /**
     * Returns all EndEvents contained in this process.
     */
    getEndEvents() {
        return this.flowNodes.filter((entry) => entry.bpmnType === Constants_1.BpmnType.endEvent);
    }
    /**
     * Returns all FlowNodes that match the given type.
     */
    getFlowNodesByType(bpmnType) {
        return this.flowNodes.filter((entry) => entry.bpmnType === bpmnType);
    }
}
exports.Process = Process;
//# sourceMappingURL=Process.js.map